import React from "react";
import Avatar from "@komon/modal/avatar";
import {
  useCurrentUser,
  useCurrentUserLocale,
  useDeleteUserPicture,
  useUploadUserPictures,
  useUserPictures,
} from "../user/use-cases";

interface IProps {
  picture: number;
  onCancel: () => void;
  onValidate: (picture: { id?: number; url?: string }) => void;
}

const ProfileAvatar = ({ picture, onCancel, onValidate }: IProps) => {
  const locale = useCurrentUserLocale();
  const user = useCurrentUser();
  const { pictures } = useUserPictures(user);
  const deleteAvatar = useDeleteUserPicture(user);
  const uploadAvatars = useUploadUserPictures(user);
  return (
    <Avatar
      locale={locale}
      pictures={pictures}
      picture={picture}
      onCancel={onCancel}
      onDelete={deleteAvatar}
      onValidate={onValidate}
      onUpload={uploadAvatars}
    />
  );
};

export default ProfileAvatar;
